
export function _setProductListArray(state, responseData) {
    state.productList = responseData
}

